import { Elements, Descriptions, Element, Tag } from 'types';
import { valueLogger } from 'utils';

export interface ILoader {
  loadBase: () => Promise<Elements>,
  loadDescriptions: () => Promise<Descriptions>,
  loadTags: () => Promise<Tag[]>,
}

export class StandardBaseManager {
  public elements: Elements = {};
  public descriptions: Descriptions = {};
  public tags: Tag[] = [];
  protected loader!: ILoader;

  public init(loader: ILoader) {
    this.loader = loader;
  }

  public async loadBase() {
    const elements = await this.loader.loadBase();
    this.elements = elements;
    valueLogger('base', 'elements loaded', { elements });

    return this.elements;
  }
  public async loadDescriptions() {
    const descriptions = await this.loader.loadDescriptions();
    this.descriptions = descriptions;
    valueLogger('base', 'descriptions loaded', { descriptions });

    return this.descriptions;
  }
  public async loadTags() {
    const tags = await this.loader.loadTags();
    this.tags = tags;
    valueLogger('base', 'tags loaded', { tags });

    return this.tags;
  }

  public elementAdd(id: Element['id'], element: Element) {
    this.elements[id] = element;
    return this.elements;
  }
  public elementRemove(id: Element['id']) {
    delete this.elements[id];
    return this.elements;
  }

  public getElementById(rawId: string) {
    const id = `${ rawId }`;
    if (!this.elements.hasOwnProperty(id)) {
      return null;
    }

    return this.elements[id];
  }
  public getDescriptionById(rawId: string) {
    const id = `${ rawId }`;
    if (!this.descriptions.hasOwnProperty(id)) {
      const element = this.getElementById(id);
      if (element && element.description.length) {
        return element.description;
      }

      return '';
    }

    return this.descriptions[id];
  }
}
